// @flow

import { connect } from "react-redux";
import React from "react";
import { Avatar } from "@chakra-ui/react";

import * as colors from "src/styles/constants/colors";

import { getUser } from "src/reducers";
import type { AppState } from "src/types";

type Props = {
  size?: string,
  email: string,
  photoUrl: string,
  displayName: string,
};

export const Photo = ({ size = "sm", email, photoUrl, displayName }: Props) => {
  return (
    <Avatar
      name={displayName || email}
      src={photoUrl}
      size={size}
      bg={photoUrl ? "transparent" : colors.unifizeBlue}
      color="white"
    />
  );
};

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  ...getUser(app, props.uid),
});

export default connect(mapStateToProps)(Photo);
